<template>
  <b-card title="Новая полоска">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col md="6">
            <b-form-group label="Название">
              <validation-provider rules="required|min:3" v-slot="{ errors }">
                <b-form-input v-model="form.name" placeholder="Назовите полоску" :state="errors.length ? false : null" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group label="Автор">
              <v-select
                v-model="form.author_name"
                :options="authorsOptions"
                :reduce="opt => opt.value"
                label="label"
                :placeholder="isLoadingAuthors ? 'Загрузка…' : 'Выберите автора'"
                taggable
                :disabled="isLoadingAuthors"
              />
            </b-form-group>

            <b-form-group label="Формат вопросов (опционально)">
              <v-select
                v-model="form.format"
                :options="formatOptions"
                :reduce="opt => opt.value"
                label="label"
                placeholder="— Разные форматы —"
              />
              <small class="text-muted">Если не задан, формат выбирается отдельно у каждого вопроса.</small>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Шкала цен">
              <b-form-radio-group v-model="form.scale_type" :options="scaleOptions" />
            </b-form-group>

            <b-form-group v-if="form.scale_type === 'flat'" label="Номинал">
              <v-select
                v-model="form.base_price"
                :options="basePriceOptions"
                :reduce="opt => opt.value"
                label="label"
              />
            </b-form-group>

            <b-form-group label="Сложность">
              <b-form-rating v-model="form.difficulty" no-border :stars="5" variant="warning" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-button type="submit" variant="primary" :disabled="invalid || isSaving">
          <b-spinner v-if="isSaving" small />
          Создать
        </b-button>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormRating, BButton, BRow, BCol, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { ref } from '@vue/composition-api'
import store from '@/store'
import { required, min } from '@validations'

export default {
  components: {
    BCard, BForm, BFormGroup, BFormInput, BFormRadioGroup, BFormRating, BButton, BRow, BCol, BSpinner,
    vSelect, ValidationObserver, ValidationProvider,
  },
  setup(props, { emit }) {
    const form = ref({
      name: '',
      author_name: null,
      format: null,
      scale_type: 'ascending',
      base_price: 100,
      difficulty: 3,
    })
    const isSaving = ref(false)
    const authorsOptions = ref([])
    const isLoadingAuthors = ref(false)

    const formatOptions = [
      { label: 'Угадай мелодию', value: 'guess_melody' },
      { label: 'Обложка', value: 'cover_art' },
      { label: 'Кавер', value: 'cover_song' },
    ]
    const scaleOptions = [
      { text: 'Возрастающая (100→500)', value: 'ascending' },
      { text: 'Плоская', value: 'flat' },
    ]
    const basePriceOptions = [
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '300', value: 300 },
    ]

    isLoadingAuthors.value = true
    store.dispatch('strip-builder/fetchAuthors')
      .then(response => {
        authorsOptions.value = (response.data || []).map(a => ({
          label: a.name,
          value: a.name,
        }))
      })
      .catch(() => {})
      .finally(() => { isLoadingAuthors.value = false })

    const onSubmit = () => {
      isSaving.value = true
      const payload = { ...form.value }
      if (payload.scale_type !== 'flat') {
        payload.base_price = null
      }
      emit('create', payload)
    }

    const stopLoading = () => {
      isSaving.value = false
    }

    return {
      form, isSaving, authorsOptions, isLoadingAuthors, formatOptions, scaleOptions, basePriceOptions, onSubmit, stopLoading,
      required, min,
    }
  },
}
</script>
